import { FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material';
import _ from 'lodash';
import { FacilitySelect } from '../../../../components/select/SelectList';
import { FormLabelText } from '../../../../components/style/TextStyle';
import { CategoryTypeList } from '../../../../utils/enum';
import {
  TextAreaInput,
  TextInput,
} from '../../MapPage/FacilityFormPage/CommonForm';
import MarkerImageInput from '../MarkerImageInput';

export function CreateTypeForm({ form }: any) {
  return (
    <Stack sx={{ w: '100%' }} spacing={4}>
      <Stack sx={{ flex: 1 }}>
        <TextInput
          form={form}
          isRequired={true}
          label="구분"
          fieldPath="title"
          placeholder="예시 : 수영장"
        />
      </Stack>
      <Stack>
        <FormLabelText>
          구분 종류<span>*</span>
        </FormLabelText>
        <RadioGroup row value={CategoryTypeList.REGULAR}>
          <FormControlLabel
            defaultChecked={true}
            value={CategoryTypeList.REGULAR}
            control={<Radio size="small" />}
            label="그 외 시설"
          />
        </RadioGroup>
      </Stack>
      <Stack>
        <FormLabelText>마커 이미지</FormLabelText>
        <MarkerImageInput form={form} />
      </Stack>
      <Stack>
        <TextAreaInput
          form={form}
          isRequired={false}
          label="비고"
          fieldPath="notes"
          placeholder="예시 : 비고 추가 작성"
        />
      </Stack>
    </Stack>
  );
}

export function CreateSportingForm({ form }: any) {
  const { errors, touchedFields: touched } = form.formState;

  return (
    <Stack sx={{ w: '100%' }} spacing={4}>
      <Stack sx={{ flex: 1 }}>
        <TextInput
          form={form}
          isRequired={true}
          label="운동기구명"
          fieldPath="title"
          placeholder="예시 : 윗몸일으키기 + 팔굽혀펴기"
        />
      </Stack>
      <Stack>
        <FormLabelText>
          기구 분류<span>*</span>
        </FormLabelText>
        <FacilitySelect
          value={form.watch('subCategoryType')}
          onChange={(e: any) =>
            form.setValue('subCategoryType', e.target.value)
          }
          formControlProps={{
            error: Boolean(touched.subCategoryType && errors.subCategoryType),
          }}
          helperText={_.get(errors, 'subCategoryType.message') as string}
        />
      </Stack>
      <Stack>
        <TextAreaInput
          form={form}
          isRequired={false}
          label="비고"
          fieldPath="notes"
          placeholder="예시 : 비고 추가 작성"
        />
      </Stack>
    </Stack>
  );
}

export function CreateStatusForm({ form }: any) {
  return (
    <Stack sx={{ w: '100%' }} spacing={4}>
      <Stack sx={{ flex: 1 }}>
        <TextInput
          form={form}
          isRequired={true}
          label="상태명"
          fieldPath="title"
          placeholder="예시 : 부품파손"
        />
      </Stack>
      <Stack>
        <TextAreaInput
          form={form}
          isRequired={false}
          label="비고"
          fieldPath="notes"
          placeholder="예시 : 비고 추가 작성"
        />
      </Stack>
    </Stack>
  );
}

export function CreateDepartmentForm({ form }: any) {
  return (
    <Stack sx={{ w: '100%' }} spacing={4}>
      <Stack sx={{ flex: 1 }}>
        <TextInput
          form={form}
          isRequired={true}
          label="부서명"
          fieldPath="title"
          placeholder="예시 : 광주 북구청 도로과"
        />
      </Stack>
      <Stack>
        <TextAreaInput
          form={form}
          isRequired={false}
          label="비고"
          fieldPath="description"
          placeholder="예시 : 비고 추가 작성"
        />
      </Stack>
    </Stack>
  );
}
